import dayjs from 'dayjs'

export const getYears = (actualDate: Date | null, date: Date | null | undefined): number => {
    if (actualDate === null || date === null || date === undefined) {
        return 0;
    }
    return dayjs(actualDate).diff(date, 'years', true);
}

// Date-only strings ("YYYY-MM-DD") have to be read in local time: new Date()
// parses them as UTC midnight, which the date pickers then render as the
// previous day in any timezone west of UTC.
export const parseDateOnly = (date: string): Date => {
    return dayjs(date).toDate();
}
